import {
    collection,
    CollectionReference,
    DocumentData,
    Timestamp,
    getCountFromServer,
    doc,
    addDoc,
    deleteDoc,
    getDocs,
    query,
    orderBy
} from "firebase/firestore";

import { fs } from "../firebase.ts";
import { Reader } from "../models/Reader.ts";
import { getRandomNumber2 } from "../models/Number.ts";

// dummy readers
interface Buddhist {
    id?: string; // doc id
    date: Timestamp;
    latitude: number;
    longitude: number;
    address: string;
}

export class Buddhists {
    private collection: CollectionReference<DocumentData>;

    constructor() {
        this.collection = collection(fs, "buddhists");
    }

    async count(): Promise<number> {
        const snapshot = await getCountFromServer(this.collection);
        return snapshot.data().count;
    }

    async add(
        latitude: number,
        longitude: number,
        address: string
    ): Promise<Buddhist> {
        const buddhist: Buddhist = {
            date: Timestamp.now(),
            latitude,
            longitude,
            address
        };
        const docRef = await addDoc(this.collection, buddhist);

        return {
            id: docRef.id,
            ...buddhist
        };
    }

    async remove(id: string) {
        const docRef = doc(fs, "buddhists", id);
        await deleteDoc(docRef);
    }

    async get(): Promise<Reader[]> {
        const q = query(
            this.collection,
            orderBy("date", "asc") // or desc
        );
        const buddhists = await getDocs(q);
        const readers: Reader[] = [];

        buddhists.docs.forEach((doc, i) => {
            const reader = doc.data() as Buddhist;
            readers.push({
                id: doc.id,
                uid: "",
                user: "HeartBank®",
                address: reader.address,
                latitude: reader.latitude,
                longitude: reader.longitude,
                lastActive: Timestamp.now(),
                pages: getRandomNumber2(100, 2000),
                rank: i + 1
            } as Reader);
        });

        return readers;
    }
}
